<div id="appointmentInfo">
  <h4 style="color: red;">Avtalt oppdatering: </h4>
  <h4>Dato: {{exectionDate}}</h4>
  <h4>Tid: {{bookingData.time}} </h4>
  <h4>Forventet varighet: {{bookingData.durationMin}} minutter</h4>
  <h4>Bestilt av: {{bookingData.bookedBy}}</h4>
</div>
